import { useState, useEffect } from "react";

export default function Stats() {
  const [statsData, setStatsData] = useState({
    doctor: 0,
    medstudent: 0,
    nurse: 0,
    other: 0,
  });

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await fetch(
          "https://test.doctio.dk/api/statistics/professions"
        );
        const jsonData = await response.json();

        setStatsData(jsonData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }

    fetchData();
  }, []);

  return (
    <div className="bg-white container mx-auto">
      <div className="mx-auto">
        <dl className="grid grid-cols-2 py-12 border-b doctio-grey-border gap-x-2 text-center md:grid-cols-4">
          <div className="mx-auto mb-8 md:mb-0 flex w-full flex-col px-4">
            <dt className="text-center text-dbase font-medium">Læger</dt>
            <h3 className="order-first text-center text-d3xl md:text-d5xl font-light tracking-tight mb-4 text-doctio-green">
              {statsData.doctor}
            </h3>
          </div>
          <div className="mx-auto mb-8 md:mb-0 flex w-full flex-col px-4">
            <dt className="text-center text-dbase font-medium">
              Lægestuderende
            </dt>
            <h3 className="order-first text-center text-d3xl md:text-d5xl font-light tracking-tight mb-4 text-doctio-green">
              {statsData.medstudent}
            </h3>
          </div>
          <div className="mx-auto mb-8 md:mb-0 flex w-full flex-col px-4">
            <dt className="text-center text-dbase font-medium">
              Sygeplejesker
            </dt>
            <h3 className="order-first text-center text-d3xl md:text-d5xl font-light tracking-tight mb-4 text-doctio-green">
              {statsData.nurse}
            </h3>
          </div>
          <div className="mx-auto mb-8 md:mb-0 flex w-full flex-col px-4">
            <dt className="text-center text-dbase font-medium">
              Andre faggrupper
            </dt>
            <h3 className="order-first text-center text-d3xl md:text-d5xl font-light tracking-tight mb-4 text-doctio-green">
              {statsData.other}
            </h3>
          </div>
        </dl>
      </div>
    </div>
  );
}
